<template>
  <b-container class="container-layout mt-5" fluid>
    <b-row v-for="(items, key) in simulacros" :key="key" align-h="center" align-v="center">
      <b-col  v-if="!items.hijo" cols="11" :style="{ borderColor: items.color }" class="filaSimulacro">
        <b-row>
          <b-col align-self="center" cols="8">
            <p class="titutlo-simulacro-admin" :style="{ color: items.color }">{{items.nombre}}</p>
          </b-col>
          <b-col cols="2" class="mt-2 pt-1" style="text-align:right">
            <img
              @click="editarSimulacro(items.id_simulacro)"
              v-if="key>1"
              class="ml-1"
              style="cursor:pointer"
              src="@/assets/images/eddit.png"
              alt
            />
            <img
              @click="EliminarSimulacro1(items.id_simulacro)"
              v-if="key>1"
              class="ml-3"
              style="cursor:pointer"
              src="@/assets/images/erase1.png"
              alt
            />
            <img
              @click="editarSimulacro(items.id_simulacro)"
              v-if="key==0"
              class="ml-1"
              style="cursor:pointer"
              src="@/assets/images/eddit.png"
              alt
            />
            <img
              @click="EliminarSimulacro1(items.id_simulacro)"
              v-if="key==0"
              class="ml-3"
              style="cursor:pointer"
              src="@/assets/images/erase1.png"
              alt
            />
            <img
              @click="editarSimulacro(items.id_simulacro)"
              v-if="key==1"
              class="ml-1"
              style="cursor:pointer"
              src="@/assets/images/edit2.png"
              alt
            />
            <img
              @click="EliminarSimulacro1(items.id_simulacro)"
              v-if="key==1"
              class="ml-3"
              style="cursor:pointer"
              src="@/assets/images/erase2.png"
              alt
            />
          </b-col>
          <b-col cols="2">
            <button
              @click="crearTipo(items.id_simulacro)"
              :style="{ background: items.color }"
              class="button-tipo"
            >Crear tipo de examen</button>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        v-if="items.hijo"
        cols="11"
        :style="{ borderColor: items.color }"
        class="filaSimulacro"
      >
        <b-row>
          <b-col align-self="center" cols="8">
            <p class="titutlo-simulacro-admin" :style="{ color: items.color }">
              {{items.nombre}} -
              <span
                class="mt-3"
                :style="{ color: items.color }"
              >TIPO {{items.tipo}}</span>
            </p>
          </b-col>
          <b-col cols="2" class="mt-2 pt-1" style="text-align:right"></b-col>
          <b-col cols="2" class="mt-2">
            <img
              @click="editarSimulacroTipo(items.id_simulacro, items.tipo)"
              class="ml-5 mt-2"
              style="cursor:pointer"
              src="@/assets/images/eddit.png"
              alt
            />
            <img
              @click="eliminarSimulacroTipo1(items.id_simulacro, items.tipo)"
              class="ml-3 mt-2"
              style="cursor:pointer"
              src="@/assets/images/erase1.png"
              alt
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-4 m-4" align-h="start">
      <b-col cols="3">
        <p @click="goRouter()" class="plus-simulacro">
          <img src="@/assets/images/plus.png" alt />
          Agregar nuevo Simulacro
        </p>
      </b-col>
    </b-row>
     <b-modal content-class="modal-finish" hide-footer ref="modal-delete-padre" centered size="md">
      <b-row align-h="center" class="mt-5 examen-finish">
        <p class="mt-2" style="color:#0F376E">Eliminar Simulacro padre</p>
      </b-row>
      <b-row align-h="center" class="mt-4 examen-finish2">
        <p>Estas seguro que desea eliminar este simulacro padre esto eliminara todos sus simulacros hijos?</p>
      </b-row>
      <b-row align-h="center" class="mb-1 ml-1">
        <b-col lg="6">
          <button
            @click="cancel()"
            style="color:#0F376E!important"
            class="modal-button-cancel"
          >CANCELAR</button>
        </b-col>
        <b-col lg="6">
          <button
            @click="EliminarSimulacro()"
            style="background-color:#0F376E!important"
            class="modal-button-accept"
          >ACEPTAR</button>
        </b-col>
      </b-row>
    </b-modal>
      <b-modal content-class="modal-finish" hide-footer ref="modal-delete-hijo" centered size="md">
      <b-row align-h="center" class="mt-5 examen-finish">
        <p class="mt-2" style="color:#0F376E">Eliminar Examen</p>
      </b-row>
      <b-row align-h="center" class="mt-2 examen-finish2">
        <p>Estas seguro que desea eliminar este tipo de examen?</p>
      </b-row>
      <b-row align-h="center" class="mb-1 mt-3 ml-1">
        <b-col lg="6">
          <button
            @click="cancel2()"
            style="color:#0F376E!important"
            class="modal-button-cancel"
          >CANCELAR</button>
        </b-col>
        <b-col lg="6">
          <button
            @click="eliminarSimulacroTipo()"
            style="background-color:#0F376E!important"
            class="modal-button-accept"
          >ACEPTAR</button>
        </b-col>
      </b-row>
    </b-modal>
  </b-container>
</template>

<script>
export default {
  name: "Cuentas",
  data: () => ({
    simulacros: [],
    premedios: [],
    id: "",
    tipo: ""
  }),
  created() {
    this.$store.dispatch("setModulo", "SIMULACRO");

    this.getSimulacros();
  },
  methods: {
    goRouter() {
      this.$router.push("simulacro/new");
    },
    cancel(){
    this.$refs["modal-delete-padre"].hide();
    },
    cancel2(){
    this.$refs["modal-delete-hijo"].hide();
    },
    EliminarSimulacro1(id) {
      this.$refs["modal-delete-padre"].show();
      this.id = id;
    },
    EliminarSimulacro() {
      let data = {
        id_simulacro: this.id,
        tipo: "P"
      };
      this.$store
        .dispatch("eliminarSimulacro", data)
        .then(response => {
          console.log(response.data);
          this.getSimulacros();
             this.$refs["modal-delete-padre"].hide();
        })
        .catch(error => {
          console.log(error.message);
        });
    },
    eliminarSimulacroTipo1(id, tipo) {
          this.$refs["modal-delete-hijo"].show();
      this.id = id;
      this.tipo = tipo;
    },
    eliminarSimulacroTipo() {
      let data = {
        id_simulacro: this.id,
        tipo: this.tipo
      };
      this.$store
        .dispatch("eliminarSimulacroTipo", data)
        .then(response => {
          console.log(response.data);
          this.$refs["modal-delete-hijo"].hide();
          this.getSimulacros();
        })
        .catch(error => {
          console.log(error.message);
        });
    },
    crearTipo(id) {
      localStorage.setItem("id_simulacro", id);
      this.$router.push("simulacro/newtipo");
    },
    editarSimulacro(id) {
      localStorage.setItem("id_simulacro", id);
      this.$router.push("simulacro/edit");
    },
    editarSimulacroTipo(id, tipo) {
      localStorage.setItem("id_simulacro", id);
      localStorage.setItem("tipo", tipo);

      this.$router.push("simulacro/editTipo");
    },

    getSimulacros() {
      this.$store
        .dispatch("getSimulacrosAdmin")
        .then(response => {
          this.simulacros = response.data.simulacro;
          this.simulacros.forEach((element, index) => {
            if (index == 0) {
              element.color = "#0F376E";
            }
            if (index == 1) {
              element.color = "#FF7451";
            }
            if (index > 1) {
              element.color = "black";
            }
          });
        })
        .catch(error => {
          console.log(error.message);
        });
    }
  },
  filters: {
    fixed(value) {
      return parseFloat(value).toFixed(0);
    }
  }
};
</script>
<style scoped>
</style>